/**
 * Gera o PDF "Por que consórcio": estudo.ts faz a conta, estudoPaginas.ts
 * desenha, e aqui só se carrega a fonte e se fotografa página a página.
 * O link do estudo (estudoLink.ts) mostra as mesmas páginas na tela.
 */
import { renderPaginasToPdf } from '@/lib/htmlToPdf';
import type { Estudo } from './estudo';
import { montarPaginas } from './estudoPaginas';
import type { UserInfo } from './proposal-utils';

const FONTE_URL = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap';

/**
 * Montserrat é a fonte do logo da North. Carrega uma vez; se a rede falhar ou
 * demorar, o PDF sai em Helvetica — nunca espera mais que 3 segundos.
 */
export const carregarFonte = async () => {
  if (!document.querySelector(`link[href="${FONTE_URL}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTE_URL;
    document.head.appendChild(link);
  }
  if (!document.fonts?.load) return;
  await Promise.race([
    Promise.all(['400', '700', '800'].map((peso) => document.fonts.load(`${peso} 20px Montserrat`))),
    new Promise((resolve) => setTimeout(resolve, 3000)),
  ]).catch(() => undefined);
};

/** Fotografa as páginas do estudo (com as seções que o vendedor deixou) e baixa o PDF. */
export const baixarEstudoPdf = async (estudo: Estudo, userInfo: UserInfo) => {
  await carregarFonte();
  const paginas = montarPaginas(estudo, userInfo, window.location.origin).map((html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.firstElementChild as HTMLElement;
  });
  const nome = estudo.cliente ? `-${estudo.cliente.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}` : '';
  await renderPaginasToPdf(paginas, `apresentacao-consorcio-north${nome}-${new Date().toISOString().split('T')[0]}.pdf`);
};
